import styled, { css } from "@xstyled/styled-components";

import { Clickable } from "@otta/design";
import { RoundedTag } from "@hire/components/tags/RoundedTag";

const Container = styled.div`
  display: flex;
  gap: xs;
`;

const Tag = styled(RoundedTag)<{ active?: boolean }>(
  ({ active }) => css`
    background-color: ${active ? "yellow-500" : "beige-100"};

    &:hover {
      background-color: ${active ? "yellow-200" : "beige-200"};
    }
  `
);

interface ConversationFilterTypeProps {
  composeSearch(key: string, value?: string): void;
  receivesApplicationsWithinOtta: boolean;
  showApplications: boolean;
  showSourced: boolean;
}

export function ConversationTypeFilter({
  composeSearch,
  receivesApplicationsWithinOtta,
  showApplications,
  showSourced,
}: ConversationFilterTypeProps) {
  return (
    <Container>
      {receivesApplicationsWithinOtta && (
        <Clickable
          onClick={() =>
            composeSearch("applied", showApplications ? undefined : "true")
          }
        >
          <Tag content="Applications" icon="apply" active={showApplications} />
        </Clickable>
      )}
      <Clickable
        onClick={() =>
          composeSearch("sourced", showSourced ? undefined : "true")
        }
      >
        <Tag content="Sourced" icon="sourcing" active={showSourced} />
      </Clickable>
    </Container>
  );
}
